import { ReactNode, useEffect, useState } from "react";
import { Button } from "../Control/Button/Button";
import { classNamesOrEmpty } from "../../style/common";

export type ItemDisplayPropClasses = {
    container?: string | undefined,
    resultsContainer?: string | undefined,
    filterApplyContainer?: string | undefined,
    itemsContainer?: string | undefined
} | undefined

export type ItemDisplayProps<TItem> = {
    items: TItem[],
    itemsDisplayed: number,
    itemComponentGenerator: (item: TItem, index: number) => ReactNode,
    onShowMoreClick: () => void,
    displayContainerId?: string,
    classNames?: ItemDisplayPropClasses
}

export const ITEM_DISPLAY_STYLES = {
    default: "grid grid-cols-1 gap-x-4 gap-y-10 sm:gap-x-6 sm:grid-cols-2 md:grid-cols-3 lg:gap-x-8 xl:grid-cols-4 3xl:grid-cols-5 4xl:grid-cols-6 mt-6 !overflow-visible pb-12",
    compact: "grid gap-y-10 !grid-cols-2 sm:!grid-cols-4 md:!grid-cols-4 lg:!grid-cols-4 xl:!grid-cols-6 2xl:!grid-cols-8 3xl:!grid-cols-8 !gap-x-4 max-w-7xl mx-auto",
    horizontal: "hover:scrollbar-thumb-slate-100 h-[250px] block overflow-y-hidden whitespace-nowrap px-2 overscroll-x-contain scrollbar scrollbar-track-secondary scrollbar-thumb-muted",
    wide: "grid grid-cols-1 gap-x-4 gap-y-10 sm:gap-x-6 md:grid-cols-2 lg:gap-x-8 xl:grid-cols-3 3xl:grid-cols-3 4xl:grid-cols-5 mt-6 overflow-visible pb-12",
    list: "mt-6 max-w-2xl mx-auto"
}
 
export function ItemDisplay<TItem>(props: ItemDisplayProps<TItem>) {
    const [displayedItems, setDisplayedItems] = useState<TItem[]>([]);

    const displayMoreItems = () => {
        setDisplayedItems(props.items.slice(0, props.itemsDisplayed));
    }

    useEffect(() => {
        if (!props.items) {
            return;
        }

        displayMoreItems();
    }, []);

    useEffect(() => {
        displayMoreItems();
    }, [props.items, props.itemsDisplayed]);

    return (
        <div className={classNamesOrEmpty(props.classNames?.container)}>
            {
                // NO RESULTS
                (!!!props.items?.length) &&
                <span className="flex justify-center text-lg font-medium text-gray-400 p-10 whitespace-break-spaces">No Results</span>
            }

            {
                displayedItems.length > 0 &&
                <div id={props.displayContainerId} className={classNamesOrEmpty(props.classNames?.itemsContainer ?? ITEM_DISPLAY_STYLES.default)}>
                    {
                        displayedItems.map((item, index) => (
                            props.itemComponentGenerator(item, index)
                        ))
                    }
                </div>
            }

            {
                displayedItems.length < props.items.length &&
                <div className="w-full flex mt-4">
                    <Button onClick={() => props.onShowMoreClick()} size="xl" className="m-auto">Show More</Button>
                </div>
            }
        </div>
    )
}